"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _imageUpload = _interopRequireDefault(require("../imageUpload"));

require("./index.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Images = function Images(_ref) {
  var photos = _ref.photos,
      handleChange = _ref.handleChange;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "pb-3 w-full"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "location-details-section"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "font-lato text-lightBlue mb-2 mt-4"
  }, "Images"), /*#__PURE__*/_react.default.createElement(_imageUpload.default, {
    photos: photos,
    handleChange: handleChange
  })));
};

var _default = Images;
exports.default = _default;